<template>
  <div class="ad-group__title">{{ data.title }}</div>
</template>

<script>
export default {
  name: 'GroupNode',
  props: {
    data: { type: Object, default: () => ({}) },
  },
};
</script>
